// extracted by mini-css-extract-plugin
module.exports = {"supportTab":"SupportTab_supportTab__OZqc5","title":"SupportTab_title__p43e0","content":"SupportTab_content__JPSMi","link":"SupportTab_link__a_hXv"};